import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}